export const CustomBreakpoints = {
    phone: '(max-width: 479px)',
    'phone-landscape': '(min-width: 480px) and (max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 1023px)',
    desktop: '(min-width: 1024px) and (max-width: 1199px)',
    'desktop-large': '(min-width: 1200px) and (max-width: 1439px)',
    'desktop-large-big': '(min-width: 1440px)',
};
